@if (!!player.currentTrack) {
  <section class="player theme-player__bg">
    <bmcore-progress-bar [showTimesTooltip]="true"></bmcore-progress-bar>
    <div class="common-container" [ngClass]="{ 'common-container--color-settings': colorSettingsMode }">
      <div class="player__container">
        <bmcore-track-descr
          class="player__track-descr-box"
          [fixedBeat]="player.trackData"
          [parentComponent]="'player'"
          [appType]="appType"
          [showVerificationIcon]="showVerificationIcon"
          [verificationIconSize]="12"
        >
        </bmcore-track-descr>
        <bmcore-player-controls
          class="player__controls-box"
          [showRepeatBtn]="true"
          [showShuffleBtn]="true"
        ></bmcore-player-controls>
        <div class="player__tools-box">
          <bmcore-track-actions
            [showLikeBtn]="showLikeBtn"
            [showFavouriteBtn]="showFavouriteBtn"
            [iconSize]="16"
            [track]="player?.trackData"
            (buyBtnClickEvent)="!checkIsTrackInCart(player.trackData.id) && wantToAddBeat($event, player.trackData.id)"
            [buyBtnRouterPath]="checkIsTrackInCart(player.trackData.id) ? checkoutPage : ''"
            [isTrackInCart]="checkIsTrackInCart(player.trackData.id)"
            [buyBtnText]="checkIsTrackInCart(player.trackData.id) ? lg.button.goToCart : lg.button.buy"
            [iconButtonSize]="40"
            [showIconBtnVariant]="true"
            [showDownloadFreeBeatText]="true"
            [showShareBtn]="showShareBtn"
          >
            <bmcore-player-volume-control class="player__sound-range-container"></bmcore-player-volume-control>
          </bmcore-track-actions>
        </div>
      </div>
    </div>
  </section>
}
